export const seoMixin = {
  methods: {
    getHead(info) {
      const imageUrl = info.url
        ? info.url
        : this.$config.axios.browserBaseURL.replace('api/', '') +
          `assets/637726776459452791/rings.jpg`
        
      return {
        title: info.title,
        description: info.description,
        meta: [
          {
            name: 'og:title',
            content: info.title,
          },
          {
            name: 'og:image',
            content: imageUrl,
          },
        ],
      }
    },
    getHeadScripts() {
      return {
        script: [
          {
            hid: 'stripe',
            type: 'text/javascript',
            src: this.$config.squareurl,
            defer: true,
          },
        ]
      }
    },
  },
}
